import { createSelector } from '@reduxjs/toolkit';

import type { VerktoyRootState } from '.';
import type { MittVerktoyItem, Verktoy } from '@src/types/minhelseentities';
import type { VerktoyState } from '@src/types/stateTypes';

export const selectLaeringsaktiviteter = (state: VerktoyRootState): MittVerktoyItem[] => state.verktoy.mineVerktoyListe;
export const selectLaeringsaktiviteterLoading = (state: VerktoyRootState): boolean => state.verktoy.laeringsaktiviteterLoading;

export const getVerktoySelector = (state: VerktoyRootState): VerktoyState => state.verktoy;

export const getVerktoyForLaeringsaktivitetSelector = createSelector(
  [(state: VerktoyRootState): MittVerktoyItem[] => state.verktoy.mineVerktoyListe, (_: VerktoyRootState, verktoyId): string => verktoyId],
  (laeringsaktiviteter, verktoyId) => {
    const verktoy = laeringsaktiviteter.filter(verktoy => verktoy.VerktoyId === verktoyId);
    if (verktoy.length === 1) {
      return {
        id: verktoy[0].VerktoyId,
        name: verktoy[0].VerktoyNavn,
      };
    } else {
      return {
        id: '',
        name: '',
      };
    }
  }
);

export const selectErLaeringsaktivitet = (state: { verktoy: { laeringsaktiviteter: Verktoy[] } }, verktoyId: string | null): boolean =>
  state.verktoy.laeringsaktiviteter.some(item => item.VerktoyId === verktoyId);

export const findAktivitetToRemoveIdSelector = createSelector(
  [
    (state: VerktoyRootState): MittVerktoyItem[] => state.verktoy.mineVerktoyListe,
    (state: VerktoyRootState): Verktoy | undefined => state.verktoy.aktivitetToRemove,
  ],
  (laeringsaktiviteter, aktivitetToRemove) => {
    if (aktivitetToRemove?.Laeringsaktivitet?.LaeringsaktivitetId) {
      return aktivitetToRemove.Laeringsaktivitet.LaeringsaktivitetId;
    }
    return laeringsaktiviteter.filter(item => item.VerktoyId === aktivitetToRemove?.VerktoyId)?.[0]?.LaeringsaktivitetId;
  }
);
